// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"082882d2","453":"1b6cd8ce","591":"dbc84d2e"}[chunkId] + ".chunk.js";
};